export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "order_item": {
            "self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Item"])},
            "order_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pedido"])},
            "quantity": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad solicitada"])},
            "unit_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio Unitario"])},
            "total_price": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Precio Total"])},
            "delivery_product": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Producto"])},
            "quantity_delivered": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad entregada"])}
          }
        }
      }
    }
  })
}